import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component
} from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { AvailableColumn } from '../interfaces';

/** What the picker needs from the hosting table component (grid context) */
export interface ColumnPickerHost {
    selectableColumns: AvailableColumn[];
    columnId(definition: AvailableColumn): string;
    isColumnChecked(definition: AvailableColumn): boolean;
    toggle(definition: AvailableColumn): void;
}

export interface ColumnPickerHeaderParams extends IHeaderParams {
    context: ColumnPickerHost;
}

/**
 * The column show/hide picker, rendered in the actions column's header as
 * static-table renders it in its actions heading: the `⋯` button opens a
 * popover of checkboxes, one per selectable column or group. Hidden when
 * nothing is selectable.
 */
@Component({
    selector: 'column-picker-header',
    template: `
        <button
            *ngIf="host.selectableColumns.length > 0"
            type="button"
            class="btn btn-tertiary"
            [popover]="picker"
            [outsideClick]="true"
            [adaptivePosition]="true"
            placement="left"
            container="body"
            (onShown)="pickerTooltip.hide()"
            #pickerTooltip="bs-tooltip"
            tooltip="Show/hide columns"
            angulartics2On="click"
            angularticsAction="table-columns-view"
        >
            <span class="fal fa-ellipsis-h"></span>
        </button>
        <ng-template #picker>
            <div class="column-picker">
                <div
                    *ngFor="let col of host.selectableColumns"
                    class="checkbox"
                >
                    <label>
                        <input
                            type="checkbox"
                            [id]="host.columnId(col)"
                            (click)="host.toggle(col)"
                            [checked]="host.isColumnChecked(col)"
                        />
                        <span class="cr"
                            ><i class="cr-icon glyphicon glyphicon-ok"></i>
                        </span>
                        {{ col.name }}</label
                    >
                </div>
            </div>
        </ng-template>
    `,
    styles: [
        `
            :host {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 100%;
                height: 100%;
            }
            .column-picker {
                min-width: 160px;
            }
            .column-picker label {
                white-space: normal;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnPickerHeader implements IHeaderAngularComp {
    host: ColumnPickerHost;

    constructor(private changeDetector: ChangeDetectorRef) {}

    agInit(params: ColumnPickerHeaderParams) {
        this.host = params.context;
    }

    /** Column definitions are rebuilt on every visibility change */
    refresh(params: ColumnPickerHeaderParams) {
        this.agInit(params);
        this.changeDetector.detectChanges();
        return true;
    }
}
